import React, { Component,useMemo } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import * as MuiCore from '@material-ui/core';

import * as coreSelectors from '../core/selectors';
import * as accountSelectors from '../account/selectors';
import * as accountActions from '../account/actions';
import * as AccountIcons from '../account/Icons';
import { PDFDownloadLink, Document, Page,View,Text,StyleSheet,Image } from '@react-pdf/renderer';
import logo from '../images/rubyNavLogo.png';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
// import * as Formatters from '../ui/Formatters';
import RubyTable from '../ui/RubyTable';

const borderColor = '#ffffff';

const pdfStyles = StyleSheet.create({
        title: {
        fontSize: 24,
        textAlign: 'center',
      },
      author: {
        fontSize: 12,
        textAlign: 'left',
      },
      subtitle: {
        fontSize: 18,
        margin: 12,
      },
    page: {
        fontSize: 11,
        paddingTop: 40,
        paddingLeft:60,
        paddingRight:60,
        paddingBottom:40,
        lineHeight: 2,
        flexDirection: 'column',
    },
    container: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#23394C',
        color:'white',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
    },
    row: {
        flexDirection: 'row',
        margin:'auto',
        borderBottomColor: '#23394C',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 'auto',
        fontStyle: 'bold',
    },
    callerId:{
       // width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    billableMinutes: {
       // width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    billableAgentRawSeconds: {
       // width: '15%',
    },
    date: {
       // width: '20%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    time: {
       // width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    clientType: {
       // width: '15%', 
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 36,
        borderWidth: 1,
        borderColor: '#bff0fd',
    },
    topbar:{
        height: 60,
        width:'100%',
        backgroundColor: 'white',
    },
    logo:{
        width: 200,
        height: 50,
        marginLeft: 'auto',
        marginRight: 'auto',
        // padding:10,
        // backgroundColor: '#23394C',
    },
    subheading:{
        marginTop:30,
        fontSize:18,
    }
});

const styles = theme => ({
    root:{
        marginTop:20,
    },page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
      },
      section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
      },
      downloadBtn:{
        margin:10
      },
      navigationLogo:{
        backgroundColor: '#23394C',
      },
      tableContainer:{
          maxHeight:220,
      },
});

const DownloadPdf = ({MyDoc,invoiceId,LoadingBtn}) => {    
    return useMemo(
      () => {
            return (<PDFDownloadLink document={<MyDoc invoiceId={invoiceId} />} style={{textDecoration:'none'}} fileName="Monthly Report.pdf">
            {({ blob, url, loading, error }) => (loading ? <MuiCore.CircularProgress color="primary"/> : <LoadingBtn /> )}
            </PDFDownloadLink>)
      },
      [invoiceId],
    )
  }

class CallVolumeReport extends Component {

    state = {
        toggleDownload : false,
        downloadPdfOpen:false,
        filterLabels:"",
        checked:[],
        downloadType:'pdf'
      }

    handleToggle = (value) => () => {
        const currentIndex = this.state.checked.indexOf(value);
        const newChecked = [...this.state.checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        this.setState({checked:newChecked});
    };
    
    exportToCSV = () => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        // const ws = XLSX.utils.json_to_sheet(this.props.tasksByInvoice.tasks);
        // console.log(ws);
        //  /* hide second column */
        //  ws['!cols'] = [];
        //  ws['!cols'][0] = { hidden: true };
        //  ws['!cols'][7] = { hidden: true };
        //  ws['!cols'][8] = { hidden: true };
        //  ws.A1.v = "Caller Id";
        // console.log(ws['!cols'][8])

        let tasksByInvoice = this.props.tasksByInvoice.tasks;
        //let extraFields = this.state.checked;

        console.log(tasksByInvoice)

        var ws_data = [["Task Id","Date","Time","Caller Id","Outcome","Billable Mins","Group Name","Form Name"]];

        //add custom columns based on user selection

        // extraFields.forEach(element => {
        //     ws_data[0].push(element);
        // });

        tasksByInvoice.forEach(item => {
            var row=[];
            row.push(item.taskId)
            row.push(new Date(item.createdDate).toLocaleDateString())
            row.push(new Date(item.createdDate).toLocaleTimeString())
            row.push(item.ani)
            row.push(item.contactDescription === "null" ? "" : item.contactDescription)
            if(item.lastMessageId && item.lastMessageId === item.messageId){
                row.push(item.billableMinutes)
            }else{
                row.push(0);
            }
           
            row.push(item.groupName)
            row.push(item.formName)
            if(item.formContentJson && item.formContentJson.fields){
                item.formContentJson.fields.forEach(element => {
                    row.push(element.value);
                })
            }
         
            // extraFields.forEach(element => {
            //     row.push(item.formContentJson ? item.formContentJson[element] : "");
            // })
            ws_data.push(row)
        })
        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, "MonthlyReport" + fileExtension);
        this.setState({downloadPdfOpen:false,checked:[]})
    }

    showDownloadOptions = (value) => {
        this.setState({downloadPdfOpen:true,downloadType:value})
    }

    generatePdf = () => {
        this.setState({toggleDownload:true})
    }

    handleChange = (event) => {
        this.setState({filterLabels:event.target.value})
        
    }

    render() {
        const { classes } = this.props; 

        const LoadingBtn = () =>  <MuiCore.Button variant="contained"  onClick={() => this.setState({downloadPdfOpen: false,checked:[],toggleDownload:false })} className={classes.downloadBtn} startIcon={<AccountIcons.PdfIcon />}>Download</MuiCore.Button>;

        const MyDoc = ({invoiceId}) => {
            
            let account = this.props.account;
            let tasksByInvoice = this.props.tasksByInvoice;
            //let extraFields = this.state.checked;
            let extraFields = [];
            return (<Document>
                <Page size="A4" style={pdfStyles.page} orientation="landscape">
                <View style={pdfStyles.topbar}>
                    <Image style={pdfStyles.logo} src={logo} /> 
                </View>
                
                <View style={pdfStyles.reportHeader}>
                   <Text style={pdfStyles.title}>Activity Report</Text> 
                   <View style={{display:'flex',alignItems:'right',justifyContent:'space-around'}}>
                    <Text style={pdfStyles.author}>Invoice : {invoiceId === -1 ? "Current" : invoiceId}</Text>
                    <Text style={pdfStyles.author}> Account: {account.accountName}</Text> 
                    <Text style={pdfStyles.author}> Display Name: {account.displayName}</Text>
                   </View>
                </View>
    
                <View style={pdfStyles.subheading}>
                    <Text style={pdfStyles.author}>Inbound Calls</Text>
                </View>
    
                <View style={{flexDirection:'row',alignItems:'center',textAlign:'center',backgroundColor:'#23394C',padding:2,color:'white',marginTop:10}}>
                    <Text style={{width:'30%'}}>Calls</Text>
                    <Text style={{width:'30%'}}>Billable Minutes</Text>
                    <Text style={{width:'30%'}}>Total Call Time</Text>
                </View>
    
                <View style={{flexDirection:'row',alignItems:'center',textAlign:'center'}}>
                    <Text style={{width:'30%'}}>{tasksByInvoice.inboundTasks.length}</Text>
                    <Text style={{width:'30%'}}>{tasksByInvoice.inboundMinutes}</Text>
                    <Text style={{width:'30%'}}>{tasksByInvoice.inboundTime}</Text>
                </View>
    
                <View style={pdfStyles.tableContainer}>
                    <View style={pdfStyles.container}>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Date</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Time</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Caller Id</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Outcome</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Billable Mins</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Group Name</Text>
                        {extraFields && extraFields.length>0 && extraFields.map((item) => 
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'left',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item}</Text>
                        )}
                    </View>
                    {tasksByInvoice && tasksByInvoice.inboundTasks.map((item) => 
                        <View style={pdfStyles.row} key={item.taskId} wrap={false}>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{new Date(item.createdDate).toLocaleDateString()}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{new Date(item.createdDate).toLocaleTimeString()}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item.ani}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item.contactDescription === "null" ? "" : item.contactDescription}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item.lastMessageId && item.lastMessageId === item.messageId ? item.billableMinutes : 0}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item.groupName}</Text>
                            {extraFields && extraFields.length>0 && extraFields.map((element) => 
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'left',borderRightColor:'#FFFFFF',borderRightWidth: 1,display:'flex',flexWrap:'wrap'}}>{item.formContentJson ? item.formContentJson[element] : ""}</Text>
                            )}
                    </View>
                    )}
                </View>
    
                <View style={pdfStyles.subheading}>
                    <Text style={pdfStyles.author}>Outbound Calls</Text>
                </View>
    
                <View style={{flexDirection:'row',alignItems:'center',textAlign:'center',backgroundColor:'#23394C',padding:2,color:'white',marginTop:10}}>
                    <Text style={{width:'30%'}}>Calls</Text>
                    <Text style={{width:'30%'}}>Billable Minutes</Text>
                    <Text style={{width:'30%'}}>Total Call Time</Text>
                </View>
    
                <View style={{flexDirection:'row',alignItems:'center',textAlign:'center'}}>
                    <Text style={{width:'30%'}}>{tasksByInvoice.outboundTasks.length}</Text>
                    <Text style={{width:'30%'}}>{tasksByInvoice.outboundMinutes}</Text>
                    <Text style={{width:'30%'}}>{tasksByInvoice.outboundTime}</Text>
                </View>
    
                <View style={pdfStyles.tableContainer}>
                    <View style={pdfStyles.container}>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Date</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Time</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Caller Id</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Outcome</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Billable Mins</Text>
                        <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>Group Name</Text>
                        {extraFields && extraFields.length>0 && extraFields.map((item) => 
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'left',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item}</Text>
                        )}
                    </View>
                    {tasksByInvoice && tasksByInvoice.outboundTasks.map((item) => 
                        <View style={pdfStyles.row} key={item.taskId}>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{new Date(item.createdDate).toLocaleDateString()}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{new Date(item.createdDate).toLocaleTimeString()}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item.ani}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item.contactDescription}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item.billableMinutes}</Text>
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'center',borderRightColor:'#FFFFFF',borderRightWidth: 1}}>{item.groupName}</Text>
                            {extraFields && extraFields.length>0 && extraFields.map((element) => 
                            <Text style={{width:100/(6+extraFields.length)+'%',alignItems:'center',textAlign:'left',borderRightColor:'#FFFFFF',borderRightWidth: 1,display:'flex',flexWrap:'wrap'}}>{item.formContentJson ? item.formContentJson[element] : ""}</Text>
                            )}
                    </View>
                    )}
                </View>
                </Page>
            </Document>
        )};

        return (
            <div className={classes.root}>
                            {this.props.tasksByInvoice && this.props.tasksByInvoice.tasks && <RubyTable 
                                columns={
                                    [
                                        {
                                            heading: 'Date',
                                            key: 'createdDate',
                                            formatter: 'date'
                                        },
                                        {
                                            heading: 'Time',
                                            key: 'createdDate',
                                            formatter: 'time'
                                        },
                                        {
                                            heading: 'Caller ID',
                                            key: 'ani'
                                        },
                                        {
                                            heading: 'Call Type',
                                            key: 'contactDescription'
                                        },
                                        {
                                            heading:"Billable Mins",
                                            calculated: (row) => {
                                                return row.billableMinutes >0 && row.lastMessageId && row.lastMessageId === row.messageId ? row.billableMinutes : 0;
                                            }
                                        },
                                        {
                                            heading: 'Call For',
                                            key: 'groupName'
                                        }
                                    ]
                                }
                                tableData={this.props.tasksByInvoice.tasks || []}
                                tableClass={classes.tableContainer}
                                stickyHeader={true}
                                size='small'
                            />}
                            {/* <MuiCore.TableContainer className={classes.tableContainer} component={MuiCore.Paper}>
                                <MuiCore.Table stickyHeader size="small" aria-label="simple table">
                                    <MuiCore.TableHead>
                                        <MuiCore.TableRow> 
                                            <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Date</MuiCore.TableCell>
                                            <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Time</MuiCore.TableCell>
                                            <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Caller ID</MuiCore.TableCell>
                                            <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Call Type</MuiCore.TableCell>
                                            <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Billable Mins</MuiCore.TableCell>
                                            <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia-bold'}}>Call For</MuiCore.TableCell>
                                        </MuiCore.TableRow>
                                    </MuiCore.TableHead>
                                    <MuiCore.TableBody>

                                                {this.props.tasksByInvoice && this.props.tasksByInvoice.tasks && this.props.tasksByInvoice.tasks.map((item) => 
                                                <MuiCore.TableRow key={item.taskId}>
                                                    <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia'}}> {Formatters.formatDate(item.createdDate)}</MuiCore.TableCell>
                                                    <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia'}}> {Formatters.formatTime(item.createdDate)}</MuiCore.TableCell>
                                                    <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia'}}>
                                                        {item.ani}
                                                    </MuiCore.TableCell>
                                                    <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia'}}> {item.contactDescription}</MuiCore.TableCell>
                                                    <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia'}}> {item.billableMinutes}</MuiCore.TableCell>
                                                    <MuiCore.TableCell align="center" style={{fontFamily: 'Sofia'}}> {item.groupName}</MuiCore.TableCell>
                                                </MuiCore.TableRow>
                                                )}
                                            
                                    </MuiCore.TableBody>
                                </MuiCore.Table>
                            </MuiCore.TableContainer>   */}

                          

                            <MuiCore.Box style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                                <MuiCore.Button variant="contained" className={classes.downloadBtn}  style={{fontFamily: 'Sofia', fontWeight: 700}} onClick={() => this.showDownloadOptions("pdf")} startIcon={<AccountIcons.PdfIcon />}> Pdf</MuiCore.Button>

                                <MuiCore.Button variant="contained" className={classes.downloadBtn}  style={{fontFamily: 'Sofia', fontWeight: 700}} onClick={() => this.showDownloadOptions("excel")} startIcon={<AccountIcons.ExcelSaveIcon />}>Excel</MuiCore.Button>
                            </MuiCore.Box>

                            <MuiCore.Dialog open={this.state.downloadPdfOpen}
                                        onClose={() => this.setState({downloadPdfOpen: false })}>
                                    <MuiCore.DialogTitle>
                                        Download {this.state.downloadType ==='excel' ? "Excel" : "Pdf"}
                                    </MuiCore.DialogTitle>
                                    <MuiCore.DialogContent>
                                        <MuiCore.DialogContentText>
                                            {/* Select any of the information below we gathered during call handling */}
                                           { this.state.downloadType ==='excel' ? "Do you wish to Proceed with Excel Report download?" : "For detailed form content please use excel download option"}
                                        </MuiCore.DialogContentText>

                                        {/* {this.props.tasksByInvoice && this.props.tasksByInvoice.formFields &&  this.props.tasksByInvoice.formFields.map((item) => 
                                              <MuiCore.FormControlLabel
                                              control={  <MuiCore.Checkbox
                                                    edge="end"
                                                    onChange={this.handleToggle(item)}
                                                    checked={this.state.checked.indexOf(item) !== -1}
                                                    inputProps={{ 'aria-labelledby': "ff"+item,style:{color:'white'} }}
                                                />}
                                                label={item}
                                                labelPlacement="end"
                                                />
                                        )} */}

                                        </MuiCore.DialogContent>
                                    <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
                                    {this.state.toggleDownload && this.props.tasksByInvoice && this.props.tasksByInvoice.tasks && this.props.tasksByInvoice.tasks.length > 0 && 
                                        <DownloadPdf MyDoc={MyDoc}
                                        LoadingBtn = {LoadingBtn} invoiceId={this.props.selInvoice.invoiceNumber ? this.props.selInvoice.invoiceNumber : -1} classes={classes} />
                                    }
                                       {!this.state.toggleDownload && <MuiCore.Button onClick={this.state.downloadType === 'excel' ? this.exportToCSV : this.generatePdf}>
                                            Proceed
                                        </MuiCore.Button>
                                            }

                                        <MuiCore.Button onClick={() => this.setState({downloadPdfOpen:false,toggleDownload:false})}>
                                        Cancel
                                        </MuiCore.Button>
                                    </MuiCore.DialogActions>
                                    </MuiCore.Dialog>
                                        </div>);
                                }
}

const mapStateToProps = (state) => {
    return ({
      user : coreSelectors.getUser(state),
      accountId : accountSelectors.getAccountId(state),
      account : accountSelectors.getAccount(state), 
      tasksByInvoice: accountSelectors.getTasksByInvoice(state),
      invoiceId : accountSelectors.getInvoiceId(state),
      selInvoice : accountSelectors.getSelInvoice(state),
    });
  };

const mapDispatchToProps = {
    // setAccountId : accountActions.setAccountId,
    // queryAccount : accountActions.queryAccount,
    queryTasksByInvoice : accountActions.getTasksByInvoice,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CallVolumeReport));